<template>
	<div v-title title="首页" class="customize-page" :style="`backgroundColor: ${pageData.length && pageData[0].setData.background
		};`">
		<section v-for="item in pageData" :key="item.symbol">
			<Img v-if="item.id == 'tp'" :contentData="item.contentData" :setData="item.setData" />
			<Swiper v-if="item.id == 'lbt'" :contentData="item.contentData" :setData="item.setData" />
			<Search v-if="item.id == 'ss'" :setData="item.setData" />
			<SepPlaceHolder v-if="item.id == 'fgzwf'" :setData="item.setData" />
			<Nav v-if="item.id == 'twdh'" :contentData="item.contentData" :setData="item.setData" />
			<Goods v-if="item.id == 'sp'" :contentData="item.contentData" :setData="item.setData" />
			<GoodsGroup v-if="item.id == 'spfz'" :contentData="item.contentData" :setData="item.setData" />
		</section>
		<div class="h50"></div>
		<TabBar active="home"> </TabBar>
	</div>
</template>

<script>
import TabBar from '@/components/tabBar/index'
import Search from '../customize/customizedComponents/Search'
import Img from '../customize/customizedComponents/Img'
import Swiper from '../customize/customizedComponents/Swiper'
import Nav from '../customize/customizedComponents/Nav'
import SepPlaceHolder from '../customize/customizedComponents/SepPlaceHolder'
import Goods from '../customize/customizedComponents/Goods'
import GoodsGroup from '../customize/customizedComponents/GoodsGroup'
import { Toast } from 'vant'
import { post } from 'api/post'
export default {
	name: '',
	components: {
		TabBar,
		Search,
		Img,
		Swiper,
		Nav,
		SepPlaceHolder,
		Goods,
		GoodsGroup,
	},
	data() {
		return {
			id: '',
			preview: false,
			pageData: [],
		}
	},
	created() {
		this.id = this.$route.query.id || ''
		this.preview = this.$route.query.preview || false
		Toast.loading({
			duration: 0,
			forbidClick: true,
		})
		this.init()
	},
	methods: {
		init() {
			post('home/getPage', { id: this.id, preview: this.preview })
				.then((res) => {
					console.log(res)
					this.pageData = JSON.parse(res.data)
					console.log(this.pageData)
					Toast.clear()
					if (!this.pageData[0].setData.shareDes) return false
					let parameters = {
						content: [
							{
								action: 'share',
								title: '分享',
								para: {
									channel: 'WX,Wechant',
									desc: this.pageData[0].setData.shareDes,
									imageUrl: this.pageData[0].setData.shareImg,
									pageUrl: window.location.href.replace(/token=[^&]*/, "share=base"),
									title: this.pageData[0].setData.shareTitle,
								},
							},
						],
					}
					srsCallNative('JSNative', parameters, 'JSNativeCallback') //调用原生方法，'JSNativeCallback'为callback调用方法
					window.JSNativeCallback = function (result) { }
				})
				.catch(() => {
					Toast.clear()
				})
		},
	},
}
</script>

<style lang="less" scoped>
.customize-page {
	height: 100vh;
	overflow-y: auto;

	// padding-bottom: 50px;
	.h50 {
		height: 50px;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/base/index.vue